import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface ListingVideoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  videoId: number;
  videoUuid: string;
}

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideoUploadRecord>(
    'POST',
    `/api/v2/listing/${listingId}/videos/request`,
  );
